import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var FloorRuleType;
(function (FloorRuleType) {
    FloorRuleType["COMPANY"] = "COMPANY";
    FloorRuleType["HEADER_TAG"] = "HEADER_TAG";
})(FloorRuleType || (FloorRuleType = {}));
export var FloorRuleEntryMediaType;
(function (FloorRuleEntryMediaType) {
    FloorRuleEntryMediaType["ALL"] = "ALL";
    FloorRuleEntryMediaType["BANNER"] = "BANNER";
    FloorRuleEntryMediaType["VIDEO"] = "VIDEO";
    FloorRuleEntryMediaType["NATIVE"] = "NATIVE";
})(FloorRuleEntryMediaType || (FloorRuleEntryMediaType = {}));
export var FloorRuleEntryIndicator;
(function (FloorRuleEntryIndicator) {
    FloorRuleEntryIndicator["INFORMATIVE"] = "INFORMATIVE";
    FloorRuleEntryIndicator["POSITIVE"] = "POSITIVE";
    FloorRuleEntryIndicator["WARNING"] = "WARNING";
    FloorRuleEntryIndicator["NEGATIVE"] = "NEGATIVE";
    FloorRuleEntryIndicator["NEUTRAL"] = "NEUTRAL";
})(FloorRuleEntryIndicator || (FloorRuleEntryIndicator = {}));
export var RawScriptType;
(function (RawScriptType) {
    RawScriptType["COMPANY"] = "COMPANY";
    RawScriptType["HEADER_TAG"] = "HEADER_TAG";
})(RawScriptType || (RawScriptType = {}));
export var AdFormat;
(function (AdFormat) {
    AdFormat["BANNER"] = "BANNER";
    AdFormat["VIDEO"] = "VIDEO";
})(AdFormat || (AdFormat = {}));
export var UserIdModuleStorageType;
(function (UserIdModuleStorageType) {
    UserIdModuleStorageType["COOKIE"] = "COOKIE";
    UserIdModuleStorageType["HTML5"] = "HTML5";
    UserIdModuleStorageType["COOKIE_AND_HTML5"] = "COOKIE_AND_HTML5";
})(UserIdModuleStorageType || (UserIdModuleStorageType = {}));
export var PrebidClientUserIdModuleStorageType;
(function (PrebidClientUserIdModuleStorageType) {
    PrebidClientUserIdModuleStorageType["cookie"] = "cookie";
    PrebidClientUserIdModuleStorageType["html5"] = "html5";
    PrebidClientUserIdModuleStorageType["cookie&html5"] = "cookie&html5";
})(PrebidClientUserIdModuleStorageType || (PrebidClientUserIdModuleStorageType = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["SERVER"] = "SERVER";
    IntegrationType["CLIENT"] = "CLIENT";
})(IntegrationType || (IntegrationType = {}));
export var BidderConfigType;
(function (BidderConfigType) {
    BidderConfigType["SINGLE"] = "SINGLE";
    BidderConfigType["DEFAULT_SIZES"] = "DEFAULT_SIZES";
    BidderConfigType["CUSTOM_SIZES"] = "CUSTOM_SIZES";
})(BidderConfigType || (BidderConfigType = {}));
export var CustomBidderConfigType;
(function (CustomBidderConfigType) {
    CustomBidderConfigType["SINGLE"] = "SINGLE";
    CustomBidderConfigType["DEFAULT_SIZES"] = "DEFAULT_SIZES";
    CustomBidderConfigType["NONE"] = "NONE";
})(CustomBidderConfigType || (CustomBidderConfigType = {}));
export var GeoTargetingMode;
(function (GeoTargetingMode) {
    GeoTargetingMode["EXCLUDE"] = "EXCLUDE";
    GeoTargetingMode["INCLUDE"] = "INCLUDE";
})(GeoTargetingMode || (GeoTargetingMode = {}));
export var RoadblockType;
(function (RoadblockType) {
    RoadblockType["NONE"] = "NONE";
    RoadblockType["PARTIAL"] = "PARTIAL";
    RoadblockType["ALL"] = "ALL";
})(RoadblockType || (RoadblockType = {}));
export var HistoryEntityType;
(function (HistoryEntityType) {
    HistoryEntityType["HEADER_TAG"] = "HEADER_TAG";
    HistoryEntityType["PLACEMENT"] = "PLACEMENT";
    HistoryEntityType["SIZE_MAPPING"] = "SIZE_MAPPING";
    HistoryEntityType["GOOGLE_BIDDER_CONFIG"] = "GOOGLE_BIDDER_CONFIG";
    HistoryEntityType["AD_SENSE_BIDDER_CONFIG"] = "AD_SENSE_BIDDER_CONFIG";
    HistoryEntityType["AMAZON_BIDDER_CONFIG"] = "AMAZON_BIDDER_CONFIG";
    HistoryEntityType["PLACEMENT_BIDDER"] = "PLACEMENT_BIDDER";
    HistoryEntityType["BIDDER_CONFIG"] = "BIDDER_CONFIG";
    HistoryEntityType["DYNAMIC_PLACEMENT"] = "DYNAMIC_PLACEMENT";
    HistoryEntityType["FLOOR_RULE"] = "FLOOR_RULE";
    HistoryEntityType["FLOOR_RULE_ENTRY"] = "FLOOR_RULE_ENTRY";
})(HistoryEntityType || (HistoryEntityType = {}));
export var HistoryType;
(function (HistoryType) {
    HistoryType["CREATE"] = "CREATE";
    HistoryType["UPDATE"] = "UPDATE";
    HistoryType["DELETE"] = "DELETE";
})(HistoryType || (HistoryType = {}));
export var HistoryDataType;
(function (HistoryDataType) {
    HistoryDataType["TEXT"] = "TEXT";
    HistoryDataType["NUMBER"] = "NUMBER";
    HistoryDataType["BOOLEAN"] = "BOOLEAN";
    HistoryDataType["ENUM"] = "ENUM";
    HistoryDataType["PATH"] = "PATH";
    HistoryDataType["CSS"] = "CSS";
    HistoryDataType["LIST"] = "LIST";
    HistoryDataType["JSON"] = "JSON";
    HistoryDataType["ENTITY"] = "ENTITY";
})(HistoryDataType || (HistoryDataType = {}));
